import {GenericEntity} from './generic-entity.model';
import {SystemFile} from './system-file.model';
import {DictionaryItem} from './dictionary.model';
import {Partner} from './partner.model';
import {DocumentOperation} from '../enums/operations.enum';

export class Document extends GenericEntity {
    documentName: string;
    partners: Partner[];
    file: SystemFile;
    visibility: boolean;
    policyAttachment: boolean;
    category: DictionaryItem;
    description: string;
    signatureOwu: string;
    indicationOnKid: string;
    availableOperations?: DocumentOperation[];

    constructor(props = {}) {
        super(props);
        Object.assign(this, props);
    }

    isOperationEnabled(operation: string) {
        return this.availableOperations?.includes(operation as DocumentOperation);
    }

    get partnersShortNames() {
        return this.partners?.map(partner => partner.nameShort);
    }
}

export class DocumentListItem {
    id: number;
    documentName: string;
}
